import styled from 'styled-components';
import { isHexColorDark } from "../../utils/Color";
import { device } from '../../const/device';
import {
  PRIMARY_COLOR,
  SECONDARY_COLOR_5
} from '../../const/color';
import { DropIcon } from '../../const/icons';
import { FAMILY_FONT_EXTRA } from '../../const/text';

const SIZE = 32;
const SIZE_BIG = 44;

export const Wrapper = styled.div`
  position: relative;
  padding-left: 4px;
  margin-right: 35px;
`;
export const Title = styled.div`
  font-size: 12px;
  font-family: ${FAMILY_FONT_EXTRA};
  color: #52575C;
  margin-top: 11px;
  display: inline-block;
  width: 100%;
  text-align: center;
`;

export const Item = styled.div<{ color: string, title?: string, active?: boolean, big?: boolean, themeColor: string }>`
  width: ${props => props.big ? SIZE_BIG : SIZE}px;
  height: ${props => props.big ? SIZE_BIG : SIZE}px;
  background-color: ${props => props.color};
  border: 1px solid transparent;
  border-radius: 50%;
  position: relative;
  cursor: pointer;
  box-sizing: content-box;
  background-clip: padding-box;
  box-shadow: ${ props => props.themeColor =='black' ? 'none': props => props.active ? '0 0 0 2px #10CBA5' : '0 0 0 1px #E8E8E8'};
  margin-left:auto;
  margin-right:auto;

  @media (${device.mobileL}) {
    margin-left:5px;
    margin-right:5px;
  }
  
  
  &:hover {
    box-shadow: 0 0 0 2px ${props => props.active ? PRIMARY_COLOR : SECONDARY_COLOR_5};
  }
  
  &:hover:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    width: 6px;
    height: 9px;
    background: url("data:image/svg+xml,${props => DropIcon(isHexColorDark(props.color))}");
    pointer-events: none;
  }
`;
